module.exports = __webpack_public_path__ + "static/media/save.a8a3380b.png";